<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { getSmsClient } from '@/services/sms';
import { mapGetters } from 'vuex'
import { Helper, debounce } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'

const smsAxios = getSmsClient()

export default {
    page: {
      title: 'Device Status',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    mixins: [Helper],
    props: {
        formErrors: {},
    },
    components: {
        Layout,
        PageHeader,
        Multiselect
    },
    computed: {
        title() {
            return 'Status Perangkat dan History'
        },
        ...mapGetters({
            hasAccessAll: 'identity/hasAccessAll',
        }),
        visibleFields() {
            return this.tracking
        },

        tracking() {
            return [
                {
                    key: 'created_at',
                    label: this.$t('qcdevice.deviceStatus.column.date'),
                    sortable: false,
                },
                {
                    key: 'created_by.name',
                    label: this.$t('qcdevice.deviceStatus.column.name'),
                    sortable: false,
                },
                {
                    key: 'device_status.status',
                    label: this.$t('qcdevice.deviceStatus.column.latestStatus'),
                    sortable: false,
                },
                {
                    key: 'device.imei',
                    label: this.$t('qcdevice.deviceStatus.column.imei'),
                    sortable: false,
                },
                {
                    key: 'device.phoneNo',
                    label: this.$t('global.phoneNumber'),
                    sortable: false,
                },
                {
                    key: 'vehicle.license_plate',
                    label: this.$t('qcdevice.deviceStatus.column.licensePlate'),
                    sortable: false,
                },
                {
                    key: 'company.domainName',
                    label: this.$t('qcdevice.deviceStatus.column.domainName'),
                    sortable: false,
                },
                {
                    key: 'note',
                    label: this.$t('qcdevice.deviceStatus.column.note'),
                    sortable: false,
                },
            ]
        },
    },
    async mounted() {
      this.identifier = this.$route.params.identifier
      this.type = this.$route.params.type

      if (this.type == "licensePlate") {
        await this.getVehicle(this.identifier)
        this.getDevice(this.vehicle.imei)
      } else {
        this.getDevice(this.identifier)
      }
      this.getDeviceStatusLog()
      this.getDeviceStatuses()
    },
    data() {
        return {
            vehicle: null,
            device: null,
            logPerDeviceParams: {},
            deviceStatusLogs: {
                deviceStatusLogs: []
            },
            sortBy: 'createdAt',
            sortDesc: false,
            filterOn: [],
            isLoading: false,
            filter: null,
            saveLoading: false,
            form:  {
                imei: null,
                deviceStatusId: null,
                note: null,
            },
            deviceStatuses: [],
            identifier: null,
            type: null,
        }
    },
    validations: {
        form: {
            imei: { required },
            deviceStatusId: { required },
        },
    },
    methods: {
        async getDeviceStatuses() {
            const res = await smsAxios.get('/device-status')
            this.deviceStatuses = res.data.data
        },
        formatNote(item) {
          if (!item?.note) return ""

          if (item.note.includes("Dilakukan Oleh")) {
            item.note = item.note.replace("Dilakukan Oleh", "").trim()
          }

          return item.note
        },
        async getDevice(imei) {
          const params = {
            filters: [`imei eq '${imei}'`]
          }
          const res = await smsAxios.get('/device', { params }).catch((error) => {
              this.handleError(error)
          })
          
          this.device = res.data.data?.paginated_result?.[0]
        },
        async getVehicle(license_plate) {
          const params = {
            filters: [`license_plate eq '${license_plate}'`]
          }
          const res = await smsAxios.get('/vehicle', { params }).catch((error) => {
              this.handleError(error)
          })

          this.vehicle = res.data.data?.paginated_result?.[0]
        },
        async addDeviceStatusLogs() {
            this.saveLoading = true
            this.$v.form.$touch()
            if (this.$v.form.$error) {
                this.saveLoading = false
                return
            }

            const imei = this.type === 'imei' ? this.form.imei : this.vehicle.imei

            const payload = {
                device_status_logs: [
                  {
                      imei: imei,
                      device_status_id: this.form.deviceStatusId.device_status_id,
                      note: this.form.note,
                  }
                ]
            }

            await smsAxios
            .post('/device-status-log/bulk', payload)
            .then((responAxio) => {
              this.responModal(responAxio.data)
            })
            .catch((err) => {
              this.handleError(err)
            })

            await this.getDeviceStatusLog()

            this.saveLoading = false
            this.$bvModal.hide('add-log')
        },
        searchData: debounce(function () {
            this.getDeviceStatusLog()
        }, 600),
        async exportDeviceStatusLogs() {
            this.isLoading = true
            const params = {
                page: 1,
                limit: 99999,
                q: this.filter,
            }

            let sortDirection = 'desc'
            params.sorts = `createdAt:${sortDirection}`

            let filters = []

            if (this.type == 'imei') {
                filters.push('imei:eq:' + this.identifier)
            } else {
                filters.push('licensePlate:eq:' + this.vehicle.license_plate)
            }

            if (filters.length > 0) {
                params.filters = filters.join(';')
            }

            const res = await smsAxios.get('/device-status-log', { params }).catch((error) => {
                this.handleError(error)
            })
            if (!res) return

            const url = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')
            a.href = url
            a.download = 'DeviceStatusLog.xlsx'
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            this.isLoading = false
        },
        async getDeviceStatusLog() {
            this.isLoading = true
            const params = {
                page: 1,
                limit: 99999,
                q: this.filter,
            }

            let sortDirection = 'desc'
            params.sorts = `createdAt:${sortDirection}`

            let filters = []

            if (this.type == 'imei') {
                filters.push('imei:eq:' + this.identifier)
            } else {
                filters.push('licensePlate:eq:' + this.identifier)
            }

            if (filters.length > 0) {
                params.filters = filters.join(';')
            }

            const res = await smsAxios.get('/device-status-log', { params }).catch((error) => {
                this.handleError(error)
            })
            if (!res) return

            this.filteredItems = res.data.data
            this.deviceStatusLogs.deviceStatusLogs = res.data.data

            this.totalRows = res.data.total_count
            this.totalPages = res.data.total_page
            this.isLoading = false
        },
        responModal() {
            this.$toast.success(`Device Status Log Berhasil dibuat `)
            this.$root.$emit('bv::toggle::collapse', 'accordion-3')
            setTimeout(() => {
                if (!this.accordionVisible) {
                this.$root.$emit('bv::toggle::collapse', 'accordion-3')
                }
            }, 500)
        },
        addLog() {
            this.form = {
                imei: this.identifier,
            }

            this.$bvModal.show('add-log')
        },
        handleFailedValidation() {
            return
        },
        handleError(error) {
          if (error.response) {
            const errorStatus = error.response.status
            const errorData = error.response.data

            if (errorStatus === 400 && errorData.message) {
            if (errorData.message === 'license plate is already registered to another vehicle') {
                this.$toast.error(this.$t('setting.error.duplicateLicensePlate'))
                return
            }
            }

            if (errorStatus === 400 && errorData.details) {
            errorData.details.forEach((element) => {
                this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
            })
            } else if (errorStatus === 401) {
            this.$toast.error(errorData.error)
            localStorage.removeItem('token')
            localStorage.removeItem('tokenAccess')
            this.$router.push({ name: 'Login' })
            } else if (errorStatus === 403) {
            this.$toast.error(errorData.error)
            } else if (errorStatus === 409) {
            if (errorData.details) {
                errorData.details.forEach((element) => {
                this.$toast.error(`${element.message}`)
                })
            } else {
                this.$toast.error(errorData.message)
            }
            } else {
            this.$toast.error(errorData.error)
            }
          } else if (error.request) {
            this.$toast.error(error.response.statusText)
          } else {
            this.$toast.error(error.message)
          }
        },
    }
}
</script>

<template>
    <Layout>
      <PageHeader :title="title" />
      <p class="mb-4"></p>
      <div class="clearfix mc-btn-group__list">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Report & Dashboard' })"
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="ms-3"
          >
            <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
      <div
      class="row mb-3"
      v-if="this.getAccessFunc('addNewIMEI') || hasAccessAll('device-status-log:read')"
    >
      <div class="col-md-6"></div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <table class="w-25" v-if="type == 'imei'">
                <tr>
                    <td>IMEI</td>
                    <td>:</td>
                    <td>{{device?.imei}}</td>
                </tr>                <tr>
                    <td>Nomor Telepon</td>
                    <td>:</td>
                    <td>{{device?.phone_no}}</td>
                </tr>
                <tr>
                    <td>Jenis Perangkat</td>
                    <td>:</td>
                    <td>{{device?.device_name}}</td>
                </tr>    
              </table>
              <table class="w-25" v-else>
                <tr>
                    <td>Vehicle ID</td>
                    <td>:</td>
                    <td>{{vehicle?.vehicle_id}}</td>
                </tr>  
                <tr>
                    <td>Plat Nomor</td>
                    <td>:</td>
                    <td>{{vehicle?.license_plate}}</td>
                </tr>      
                <tr>
                    <td>Jenis Perangkat</td>
                    <td>:</td>
                    <td>{{device?.device_name}}</td>
                </tr>          
                <tr>
                    <td>Nomor Lambung</td>
                    <td>:</td>
                    <td>{{vehicle?.hull_no}}</td>
                </tr>
              </table>
            </div>
            <div class="clearfix">
                <div class="float-end mb-4">
                    <div
                    class="mc-table-filter"
                    v-if="
                        getAccessRight('qcDevice') ||
                        hasAccessAll(['device-status-log:read', 'device-status-log:create'])
                    "
                    >
                        <a class="popup-form btn btn-primary"
                            href="javascript: void(0);"
                            variant="secondary"
                            icon="icon-outline_upload"
                            @click="addLog()"
                        >
                            <i class="bx bx-plus"></i> {{ $t('global.addField') }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="clearfix">
              <div class="float-start">
              </div>
              <div class="float-end">
                <div class="mc-table-view">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2 form-control"
                        @input="searchData"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="deviceStatusLogs.deviceStatusLogs"
                :fields="visibleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter-included-fields="filterOn"
                :busy="isLoading"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(note)="data">
                  {{ formatNote(data.item) }}
                </template>
                <template #cell(created_at)="data">
                  {{ data.item.created_at ? momentDMHms(data.item.created_at) : '-' }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="add-log"
      ref="add-log"
      size="lg"
      title="Tambah Status"
      centered
    >
      <b-row>
        <!-- IMEI -->
        <b-col md="3">
          <div class="mb-3">
            <span class="d-block">IMEI</span>
            <strong>{{ form.imei }}</strong>
          </div>
        </b-col>
      </b-row>
      <FormulateForm
        v-model="form"
        @submit="addDeviceStatusLogs"
        :errors="formErrors"
        @failed-validation="handleFailedValidation"
      >
        <div class="mb-2">
          <label class="required">{{ $t('qcdevice.deviceStatus.selectStatus') }}</label>
          <multiselect
            v-model="form.deviceStatusId"
            :options="deviceStatuses"
            placeholder="Pilih Status"
            label="status"
            :class="{
              'is-invalid': $v.form.deviceStatusId.$error,
            }"
          />
          <div v-if="$v.form.deviceStatusId.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.form.deviceStatusId.required">
              Status Wajib Terisi
            </span>
          </div>
        </div>

        <b-form-group label="Note" label-for="note" class="mb-3">
            <b-form-textarea
            v-model="form.note"
            id="note"
            placeholder="Masukkan catatan"
            rows="6"
            :disabled="isLoading"
            />
        </b-form-group>
      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav"> </b-col>
          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button :disabled="saveLoading" variant="outline-primary" @click="cancel" class="me-3"> Batal </b-button>
            <b-button :disabled="saveLoading" type="submit" variant="primary" @click="addDeviceStatusLogs">
              <b-spinner v-if="saveLoading" small/>
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    </Layout>
</template>